import { useState, useEffect } from 'react'
import { Card, Row, Col, Spinner, Alert } from 'react-bootstrap'
import client from '../api/client'

function Dashboard() {
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await client.get('/admin/api/v1/dashboard/stats/')
        setStats(response.data)
      } catch (err) {
        setError('Erreur lors du chargement des statistiques')
        console.error(err)
      } finally {
        setLoading(false)
      }
    }
    fetchStats()
  }, [])

  if (loading) {
    return (
      <div className="d-flex justify-content-center p-5">
        <Spinner animation="border" variant="primary" />
      </div>
    )
  }

  if (error) {
    return <Alert variant="danger">{error}</Alert>
  }

  return (
    <div>
      <h1 className="h3 mb-4">Tableau de bord</h1>

      <Row className="g-4">
        <Col md={6} lg={3}>
          <Card className="stat-card h-100">
            <Card.Body>
              <Card.Title className="text-muted small">Utilisateurs</Card.Title>
              <h2 className="mb-0">{stats?.users_count || 0}</h2>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} lg={3}>
          <Card className="stat-card h-100">
            <Card.Body>
              <Card.Title className="text-muted small">Modèles actifs</Card.Title>
              <h2 className="mb-0">{stats?.active_models || 0}</h2>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} lg={3}>
          <Card className="stat-card h-100">
            <Card.Body>
              <Card.Title className="text-muted small">Requêtes (24h)</Card.Title>
              <h2 className="mb-0">{stats?.requests_24h || 0}</h2>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} lg={3}>
          <Card className="stat-card h-100">
            <Card.Body>
              <Card.Title className="text-muted small">Coût (mois)</Card.Title>
              <h2 className="mb-0">{stats?.monthly_cost_eur?.toFixed(2) || '0.00'} €</h2>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default Dashboard
